import { render, staticRenderFns } from "./TheMainSideNav.vue?vue&type=template&id=48579a7d&scoped=true"
import script from "./TheMainSideNav.vue?vue&type=script&lang=js"
export * from "./TheMainSideNav.vue?vue&type=script&lang=js"
import style0 from "./TheMainSideNav.vue?vue&type=style&index=0&id=48579a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48579a7d",
  null
  
)

export default component.exports